import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });
api.interceptors.request.use((c) => {
  if (sessionStorage.getItem("public_preview") === "1") c.headers["X-Preview"] = "public";
  return c;
});
export const media = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : null);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d?.msg || d);
};

export const ERAS = [
  { id: "silent", label: "Silent Film", range: [1890, 1929], filter: "grayscale(1) contrast(1.25) brightness(.92)", grain: 0.2 },
  { id: "sepia", label: "Sepia Portrait", range: [1930, 1959], filter: "sepia(.85) contrast(1.08) brightness(.96)", grain: 0.14 },
  { id: "faded", label: "Faded Colour", range: [1960, 1979], filter: "sepia(.25) saturate(.65) contrast(.95) brightness(1.03)", grain: 0.1 },
  { id: "analog", label: "Bright Analog", range: [1980, 1999], filter: "saturate(1.05) contrast(1.05)", grain: 0.08 },
  { id: "digital", label: "Early Digital Glass", range: [2000, 2014], filter: "saturate(.95) contrast(1.02)", grain: 0.05 },
  { id: "today", label: "Today", range: [2015, 2026], filter: "saturate(1.12) contrast(1.04) brightness(1.02)", grain: 0.04 },
];

export const eraFor = (y) => ERAS.find((e) => y >= e.range[0] && y <= e.range[1]) || ERAS[ERAS.length - 1];

export const heroFilter = (y) => {
  if (y < 1930) return "grayscale(1) contrast(1.2) brightness(.95)";
  if (y < 1960) { const t = (y - 1930) / 30; return `grayscale(${1 - t * 0.3}) sepia(${0.4 + t * 0.5}) contrast(1.08)`; }
  if (y < 1990) { const t = (y - 1960) / 30; return `sepia(${0.6 - t * 0.55}) saturate(${0.5 + t * 0.5}) contrast(1)`; }
  const t = Math.min(1, (y - 1990) / 36);
  return `saturate(${1 + t * 0.2}) brightness(${1 + t * 0.05})`;
};

export const ageFrom = (iso) => {
  if (!iso) return null;
  const b = new Date(iso);
  const n = new Date();
  let a = n.getFullYear() - b.getFullYear();
  if (n.getMonth() < b.getMonth() || (n.getMonth() === b.getMonth() && n.getDate() < b.getDate())) a -= 1;
  return a;
};

let audioCtx;
export const playNote = (enabled, freq = 523.25) => {
  if (!enabled) return;
  try {
    audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    const o = audioCtx.createOscillator();
    const g = audioCtx.createGain();
    o.type = "sine";
    o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, audioCtx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.12, audioCtx.currentTime + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 1.6);
    o.connect(g).connect(audioCtx.destination);
    o.start();
    o.stop(audioCtx.currentTime + 1.7);
  } catch (e) { /* audio unavailable */ }
};
